module.exports = __webpack_public_path__ + "media/images/social_services/zalo_primary-a812e99da0e3548e458838ce2141d3b0.svg";